/**
 * Widget Container - generischer Container für alle Widgets
 */
import React, { useState, useEffect } from 'react';
import { widgetRegistry } from '../registry';
import './WidgetContainer.scss';

const WidgetContainer = ({
  config,
  onConfigChange,
  loadData
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Lade Daten, wenn sich die Konfiguration ändert
  useEffect(() => {
    const loadDataFunction = () => {
      if (loadData) {
        setLoading(true);
        setError(null);
        
        loadData(config)
          .then(fetchedData => {
            setData(fetchedData);
            setLoading(false);
          })
          .catch(err => {
            setError('Fehler beim Laden der Daten');
            setLoading(false);
            console.error('Error loading widget data:', err);
          });
      }
    };
    
    loadDataFunction();
    
    // Event-Handler für das REFRESH_DASHBOARD-Event
    const handleRefreshDashboard = () => {
      loadDataFunction();
    };
    
    // Füge Event-Listener hinzu
    global.emitter.on('REFRESH_DASHBOARD', handleRefreshDashboard);
    
    // Entferne Event-Listener beim Unmounting
    return () => {
      global.emitter.off('REFRESH_DASHBOARD', handleRefreshDashboard);
    };
  }, [config, loadData]);

  // Handler für Datenänderungen
  const handleDataChange = (newData) => {
    setData(newData);
  };

  // Handler für Konfigurationsänderungen
  const handleConfigChange = (newConfig) => {
    if (onConfigChange) {
      onConfigChange(newConfig);
    }
  };

  // Wenn das Widget nicht aktiv ist, zeigen wir nichts an
  if (!config.isActive) {
    return null;
  }

  // Hole die Widget-Definition aus der Registry
  const widgetDefinition = widgetRegistry.getWidget(config.type);
  
  if (!widgetDefinition) {
    return (
      <div className="widget-container" data-widget-id={config.id}>
        <div className="widget-header">
          <h3 className="widget-title">{config.title}</h3>
        </div>
        <div className="widget-content">
          <div className="widget-error">
            Unbekannter Widget-Typ: {config.type}
          </div>
        </div>
      </div>
    );
  }

  // Erstelle die Widget-Komponente
  const WidgetComponent = widgetDefinition.component;

  // Bestimme die Grid-Klasse basierend auf der Größe
  const gridClass = `widget-grid-${config.size?.width || 1}x${config.size?.height || 1}`;
  
  return (
    <div className={`widget-container ${gridClass}`} data-widget-id={config.id}>
      <div className="widget-header">
        <h3 className="widget-title">{config.title}</h3>
        <div className="widget-actions">
          {/* Hier könnten zukünftig Aktionen wie Refresh, Einstellungen, etc. hinzugefügt werden */}
        </div>
      </div>
      
      <div className="widget-content">
        {loading ? (
          <div className="widget-loading">Laden...</div>
        ) : error ? (
          <div className="widget-error">{error}</div>
        ) : (
          /* Hier wird das tatsächliche Widget gerendert */
          <WidgetComponent 
            config={config}
            data={data}
            onDataChange={handleDataChange}
            onConfigChange={handleConfigChange}
          />
        )}
      </div>
    </div>
  );
};

export default WidgetContainer;
